import React from "react"
import lottie from 'lottie-web'
import MeetingExchangeButton from './MeetingExchangeButton'
import Tag from './Tag'
import DownloadAppModal from '../app_components/DownloadAppModal'
import { openAppStoreForDevice } from '../../utils/appStoreLinks'
import { isInteractiveGame } from '../games_components/activityTheme'

class TopicElement extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      saved: '',
      showing: '',
      setMeetingTopics: '',
      meetingId: '',
      showDownloadModal: false,
    }

    this.renderTags = this.renderTags.bind(this)
    this.renderMoreInfoSection = this.renderMoreInfoSection.bind(this)
    this.pressStar = this.pressStar.bind(this)
    this.renderText = this.renderText.bind(this)
    this.handleDownloadApp = this.handleDownloadApp.bind(this)
    this.closeDownloadModal = this.closeDownloadModal.bind(this)
  }


  componentWillUnmount() {
    this.setState({
      showing: false,
      setMeetingTopics: false,
      meetingId: '',
    })
  }

  componentDidMount() {

      let anim = lottie.loadAnimation({
        container: document.getElementById(`fav-star${this.props.topic.id}`),
        renderer: 'svg',
        loop: false,
        autoplay: false,
        name: `fav-star${this.props.topic.id}`,
        path: this.props.favoriteStarLottie,
      })

      if(this.props.selectedTags) {
        if(this.props.selectedTags.includes(this.props.topic.id)) {
          lottie.play(`fav-star${this.props.topic.id}`)

          this.setState({
            showing: true
          })
        }

        this.setState({
          saved: this.props.selectedTags.includes(this.props.topic.id)
        })
      }

    if(this.props.meetingId) {
      this.setState({
        setMeetingTopics: true,
        meetingId: this.props.meetingId
      })
    }

  }

  renderTags() {
    if(this.props.topic.tags != undefined) {
      let tags = this.props.topic.tags.map((tag, i) => {
        return <Tag tag={tag} key={i} selected={true}/>
      })
      return tags
    }
    return null
  }

  handleDownloadApp() {
    const shouldShowModal = openAppStoreForDevice()
    if (shouldShowModal) {
      this.setState({ showDownloadModal: true })
    }
  }

  closeDownloadModal() {
    this.setState({ showDownloadModal: false })
  }

  renderMoreInfoSection() {
    return(
      <div className="activityCard__meta">
        {this.props.topic.users != undefined &&
          <p className="activityCard__practiceCount">
            {this.props.topic.users.length + 1} people practice this
          </p>
        }
        {isInteractiveGame(this.props.topic) &&
          <a className="activityCard__playBtn" href={`/games?pack=${this.props.topic.id}`}>
            🎮 Play game
          </a>
        }
        {this.props.topic.app_only === true && !isInteractiveGame(this.props.topic) &&
          <div className="activityCard__appOnlyBlock">
            <p className="activityCard__appOnly">Only available on the mobile app.</p>
            <button
              type="button"
              className="activityCard__downloadBtn"
              onClick={this.handleDownloadApp}
            >
              Download the app
            </button>
          </div>
        }
      </div>
    )
  }

  pressStar() {
    if(this.state.saved) {
      lottie.setDirection(-1)

      lottie.play(`fav-star${this.props.topic.id}`)
      $.ajax({
        url: `../exchanges/${this.props.topic.id}/unfavorite`,
        dataType: 'JSON',
        type: 'POST',
        header: {
          'Content-Type': 'application/json'
        },
        success: (data) => {
          this.props.unfavoriteTopic(this.props.topic.id)
        },
        error: function(xhr, status, err) {
          console.log(err)
        }.bind(this)
      });
    } else {
      lottie.play(`fav-star${this.props.topic.id}`)
      $.ajax({
        url: `../exchanges/${this.props.topic.id}/favorite`,
        dataType: 'JSON',
        type: 'POST',
        header: {
          'Content-Type': 'application/json'
        },
        success: (data) => {
          this.props.favoriteTopic(this.props.topic.id)
        },
        error: function(xhr, status, err) {
          console.log(err)
        }.bind(this)
      });
    }
    this.setState({
      saved: !this.state.saved
    })
  }

  renderText() {
    return this.props.topic.body.split(/(?:\r|\n)/g).map(function(line, index) {
      return(
        <p key={index} className="activityCard__bodyLine">{line}</p>
      )
    })
  }

  render() {
    return(
      <>
      <article className="activityCard topic_element_container">
        <h4 className="activityCard__title">{this.props.topic.title}</h4>
        {this.props.favoriteStarLottie && <div
          onClick={() => this.pressStar()}
          id={`fav-star${this.props.topic.id}`}
          className="activityCard__favStar fav_star"
          role="button"
          tabIndex={0}
          aria-label={this.state.saved ? 'Remove from saved activities' : 'Save activity'}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault()
              this.pressStar()
            }
          }}
        />}
        <div className="activityCard__body">
          {this.renderText()}
        </div>
        {this.renderMoreInfoSection()}
        <div className="activityCard__tags">
          {this.renderTags()}
        </div>

        {this.state.setMeetingTopics && <MeetingExchangeButton meetingId={this.state.meetingId} topicId={this.props.topic.id}/>}
      </article>
      {this.state.showDownloadModal &&
        <DownloadAppModal onClose={this.closeDownloadModal} />
      }
      </>
    )
  }


}

export default TopicElement;
